module.exports = __webpack_public_path__ + "static/media/032.795e4b67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/032.jpg
// module id = 378
// module chunks = 0